import { ORCHESTRATION_STATES } from "../types";

/** Baseline transitions — room_session policy uses this graph. */
const TRANSITIONS = {
  proposed: ["prepared", "cancelled"],
  prepared: ["active", "cancelled"],
  active: ["paused", "completed", "cancelled", "abandoned"],
  paused: ["active", "completed", "cancelled", "abandoned"],
  completed: [],
  cancelled: [],
  abandoned: [],
};

/**
 * @param {import('../types').OrchestrationState} from
 * @param {import('../types').OrchestrationState} to
 */
export function canTransitionOrchestrationState(from, to) {
  if (!ORCHESTRATION_STATES.includes(from) || !ORCHESTRATION_STATES.includes(to)) {
    return false;
  }
  return (TRANSITIONS[from] || []).includes(to);
}

/**
 * Map V1 room match status to orchestration state (adapter use).
 * @param {import('../../roomGovernance/roomGovernanceTypes').RoomMatchStatus} roomStatus
 * @returns {import('../types').OrchestrationState}
 */
export function roomMatchStatusToOrchestrationState(roomStatus) {
  switch (roomStatus) {
    case "draft":
      return "proposed";
    case "ready":
      return "prepared";
    case "live":
      return "active";
    case "completed":
      return "completed";
    case "cancelled":
      return "cancelled";
    default:
      return "proposed";
  }
}

/**
 * @param {import('../types').OrchestrationState} state
 * @returns {import('../../roomGovernance/roomGovernanceTypes').RoomMatchStatus}
 */
export function orchestrationStateToRoomMatchStatus(state) {
  switch (state) {
    case "proposed":
      return "draft";
    case "prepared":
      return "ready";
    case "active":
    case "paused":
      return "live";
    case "completed":
      return "completed";
    case "cancelled":
    case "abandoned":
      return "cancelled";
    default:
      return "draft";
  }
}
